import {version} from "./version";

export const basePath = `https://unpkg.com/ace-builds@${version}/src-noconflict`;
